// eslint-disable-next-line camelcase
export const { REACT_APP_BASEURL = 'https://intelligrapi.intlgr3.tech/intelligrapi' } = process.env;
export const { REACT_APP_CLOSE_OPEN_LASH, REACT_APP_CLOSE_OPEN } = process.env;
export const { REACT_APP_SMSAPI_BASEURL } = process.env;
export const smsAPI = REACT_APP_SMSAPI_BASEURL;
export const path = {
  // Public
  HOMEPAGE: '/',
  // Agents
  LOGIN: '/auth',
  SUPPORT_AGENT: '/',
  DASHBOARD_AGENT: '/dashboard',
  AGENT_USER_CREATE: '/user-create',
  AGENT_USERS: '/users',
  //
  404: '/404',
  // Agents
  SCHEDULE: '/repayments/schedule',
};

export const validators = {
  phoneNumber: /^(\+?25)?07(8|9)(\d{7})$/,
  nationalId: /^[0-9]{16}$/,
};
